import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React from "react";
import { useIntl } from "react-intl";
import CustomStepper from "./customStepper/CustomStepper";

const TopTool = (props) => {
  const intl = useIntl();
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography
          textAlign="left"
          variant="subtitle2"
          sx={{ fontWeight: 700, fontSize: "16px" }}
        >
          {intl.formatMessage({
            id: "sna.sidetool.digitalAITool.ocr.step1",
            defaultMessage: "1. 檔案預覽",
          })}
        </Typography>
      </Grid>
      <Grid item>
        <CustomStepper {...props} />
      </Grid>
    </Grid>
  );
};

export default TopTool;
